<template>
  <div class="registration-phone">

    <md-toolbar class="md-primary nav-style first-nav">
      <img src="../assets/logo.png" class="logo_navbar">
    </md-toolbar>
    <div class="md-title second-navbar">COMUNICAZIONE SICURA</div>
    <form id="app" class="phone-form card-doc-upload" data-parsley-validate>


    <md-card>
      <md-card-area md-inset>
        <md-card-header>
          <span>
              Per accedere al servizio inserire il recapito telefonico di cellulare e prendere visione del trattamento dei dati personali.
              <br />Riceverai un sms con un codice numerico da inserire
              nella schermata successiva.
            </span>
          <br />
          <div class="text-card"> * campo obbligatorio </div>
          <div class="md-title title-style">Inserisci il tuo numero di telefono</div>
        </md-card-header>

        <md-card-content>

          <div class="md-layout md-gutter">
            <div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-25 md-large-size-25 md-xlarge-size-25">
              <md-field>
                <label for="patientPhPrefix">Prefisso</label>
                <md-select v-model="patientPhPrefix" name="patientPhPrefix" id="patientPhPrefix">
                  <!--<md-option value="fight-club"><span><span class="color" :style="`background-color: #ffa500`"></span>Fight Club</span></md-option>-->
                  <template v-for="country in countries">
                    <md-option :value="`${country.index}`">{{country.text}}</md-option>
                  </template>
                </md-select>
              </md-field>
            </div>
            <div class="md-layout-item">
              <md-field :class="messageClass" md-clearable>
                <label v-if='!isIE' for="patientPhNo">Numero di telefono cellulare</label>

                <label v-if='isIE' for="patientPhNo">Numero di telefono cellulare&nbsp;</label>
                <md-input v-model="patientPhNo" name="patientPhNo" type="text" id="patientPhNo" value="patientPhNo" required md-counter="10"
                  data-parsley-type="digits" data-parsley-errors-messages-disabled="true"></md-input>
                <span class="md-error" v-if="patientPhNoIsEmpty">Completare il campo per poter proseguire</span>
              </md-field>
            </div>
          </div>
        </md-card-content>
      </md-card-area>

      <md-card-content class="privacy-card">


         <md-checkbox v-model="privacy">Ho preso visione dell’<a @click.prevent="informativa($event)">informativa sul trattamento dei dati personali.</a> </md-checkbox>
      </md-card-content>

      <br />
      <md-card-actions class="button-card">
            <md-button class="md-raised md-accent submit-button" :md-ripple="false" type="submit" @click="validateRegistration($event)" :disabled="privacy == false" value="Submit">Conferma</md-button>

      </md-card-actions>
    </md-card>
    </form>

  </div>
</template>

<script>
  import firebase from 'firebase/app'
  import "firebase/auth";

  import parsley from 'parsleyjs';

  import $ from 'jquery';
  import axios from 'axios';
  import RegistrationUploadFile from '@/components/RegistrationUploadFile'


  import 'firebase/auth';
  import {
    LoginChecker
  } from '@/utils/login-check'

  export default {
    name: 'registration-phone',
    data() {
      return {
        isIE: false,
        showDialog: false,
        submitForm: {},
        patientPhPrefix:"109",
        patientPhNo: null,
        patientPhNoIsEmpty: false,
        privacy: false,
        smallScreen: false,
        countries: [
          {index: 1, text: "Afghanistan (+93)", value: "+93"},
          {index: 2, text: "Albania (+355)", value: "+355"},
          {index: 3, text: "Algeria (+213)", value: "+213"},
          {index: 4, text: "Andorra (+376)", value: "+376"},
          {index: 5, text: "Angola (+244)", value: "+244"},
          {index: 6, text: "Anguilla (+1)", value: "+1"},
          {index: 7, text: "Antigua e Barbuda (+1)", value: "+1"},
          {index: 8, text: "Antille Olandesi (+599)", value: "+599"},
          {index: 9, text: "Arabia Saudita (+966)", value: "+966"},
          {index: 10, text: "Argentina (+54)", value: "+54"},
          {index: 11, text: "Armenia (+374)", value: "+374"},
          {index: 12, text: "Aruba (+297)", value: "+297"},
          {index: 13, text: "Ascension (+247)", value: "+247"},
          {index: 14, text: "Australia (+61)", value: "+61"},
          {index: 15, text: "Austria (+43)", value: "+43"},
          {index: 16, text: "Azerbaijan (+994)", value: "+994"},
          {index: 17, text: "Bahamas (+1)", value: "+1"},
          {index: 18, text: "Bahrain (+973)", value: "+973"},
          {index: 19, text: "Bangladesh (+880)", value: "+880"},
          {index: 20, text: "Barbados (+1)", value: "+1"},
          {index: 21, text: "Belgio (+32)", value: "+32"},
          {index: 22, text: "Belize (+501)", value: "+501"},
          {index: 23, text: "Benin (+229)", value: "+229"},
          {index: 24, text: "Bermuda (+1)", value: "+1"},
          {index: 25, text: "Bhutan (+975)", value: "+975"},
          {index: 26, text: "Bielorussia (+375)", value: "+375"},
          {index: 27, text: "Bolivia (+591)", value: "+591"},
          {index: 28, text: "Bosnia Erzegovina (+387)", value: "+387"},
          {index: 29, text: "Botswana (+267)", value: "+267"},
          {index: 30, text: "Brasile (+55)", value: "+55"},
          {index: 31, text: "Brunei (+673)", value: "+673"},
          {index: 32, text: "Bulgaria (+359)", value: "+359"},
          {index: 33, text: "Burkina Faso (+226)", value: "+226"},
          {index: 34, text: "Burundi (+257)", value: "+257"},
          {index: 35, text: "Cambogia (+855)", value: "+855"},
          {index: 36, text: "Camerun (+237)", value: "+237"},
          {index: 37, text: "Canada (+1)", value: "+1"},
          {index: 38, text: "Capo Verde (+238)", value: "+238"},
          {index: 39, text: "Ciad (+235)", value: "+235"},
          {index: 40, text: "Cile (+56)", value: "+56"},
          {index: 41, text: "Cina (+86)", value: "+86"},
          {index: 42, text: "Cipro (+357)", value: "+357"},
          {index: 43, text: "Città del Vaticano (+39)", value: "+39"},
          {index: 44, text: "Colombia (+57)", value: "+57"},
          {index: 45, text: "Comore (+269)", value: "+269"},
          {index: 46, text: "Congo (+242)", value: "+242"},
          {index: 47, text: "Corea del Nord (+850)", value: "+850"},
          {index: 48, text: "Corea del Sud (+82)", value: "+82"},
          {index: 49, text: "Costa d'Avorio (+225)", value: "+225"},
          {index: 50, text: "Costa Rica (+506)", value: "+506"},
          {index: 51, text: "Croazia (+385)", value: "+385"},
          {index: 52, text: "Cuba (+53)", value: "+53"},
          {index: 53, text: "Curaçao (+599)", value: "+599"},
          {index: 54, text: "Danimarca (+45)", value: "+45"},
          {index: 55, text: "Dominica (+1)", value: "+1"},
          {index: 56, text: "Ecuador (+593)", value: "+593"},
          {index: 57, text: "Egitto (+20)", value: "+20"},
          {index: 58, text: "El Salvador (+503)", value: "+503"},
          {index: 59, text: "Emirati Arabi Uniti (+971)", value: "+971"},
          {index: 60, text: "Eritrea (+291)", value: "+291"},
          {index: 61, text: "Estonia (+372)", value: "+372"},
          {index: 62, text: "Eswatini (+268)", value: "+268"},
          {index: 63, text: "Etiopia (+251)", value: "+251"},
          {index: 64, text: "Figi (+679)", value: "+679"},
          {index: 65, text: "Filippine (+63)", value: "+63"},
          {index: 66, text: "Finlandia (+358)", value: "+358"},
          {index: 67, text: "Francia (+33)", value: "+33"},
          {index: 68, text: "Gabon (+241)", value: "+241"},
          {index: 69, text: "Gambia (+220)", value: "+220"},
          {index: 70, text: "Georgia (+995)", value: "+995"},
          {index: 71, text: "Germania (+49)", value: "+49"},
          {index: 72, text: "Ghana (+233)", value: "+233"},
          {index: 73, text: "Giamaica (+1)", value: "+1"},
          {index: 74, text: "Giappone (+81)", value: "+81"},
          {index: 75, text: "Gibilterra (+350)", value: "+350"},
          {index: 76, text: "Gibuti (+253)", value: "+253"},
          {index: 77, text: "Giordania (+962)", value: "+962"},
          {index: 78, text: "Grecia (+30)", value: "+30"},
          {index: 79, text: "Grenada (+1)", value: "+1"},
          {index: 80, text: "Groenlandia (+299)", value: "+299"},
          {index: 81, text: "Guadalupa (+590)", value: "+590"},
          {index: 82, text: "Guam (+1)", value: "+1"},
          {index: 83, text: "Guatemala (+502)", value: "+502"},
          {index: 84, text: "Guinea (+224)", value: "+224"},
          {index: 85, text: "Guinea-Bissau (+245)", value: "+245"},
          {index: 86, text: "Guinea Equatoriale (+240)", value: "+240"},
          {index: 87, text: "Guyana (+592)", value: "+592"},
          {index: 88, text: "Guyana francese (+594)", value: "+594"},
          {index: 89, text: "Haiti (+509)", value: "+509"},
          {index: 90, text: "Honduras (+504)", value: "+504"},
          {index: 91, text: "Hong Kong (+852)", value: "+852"},
          {index: 92, text: "India (+91)", value: "+91"},
          {index: 93, text: "Indonesia (+62)", value: "+62"},
          {index: 94, text: "Iran (+98)", value: "+98"},
          {index: 95, text: "Iraq (+964)", value: "+964"},
          {index: 96, text: "Irlanda (Eire) (+353)", value: "+353"},
          {index: 97, text: "Islanda (+354)", value: "+354"},
          {index: 98, text: "Isole Cayman (+1)", value: "+1"},
          {index: 99, text: "Isole Cook (+682)", value: "+682"},
          {index: 100, text: "Isola Norfolk (+672)", value: "+672"},
          {index: 101, text: "Isole Falkland (+500)", value: "+500"},
          {index: 102, text: "Isole Faroe (+298)", value: "+298"},
          {index: 103, text: "Isole Marianne Settentrionali (+1)", value: "+1"},
          {index: 104, text: "Isole Marshall (+692)", value: "+692"},
          {index: 105, text: "Isole Salomone (+677)", value: "+677"},
          {index: 106, text: "Isole Vergini Britanniche (+1284)", value: "+1284"},
          {index: 107, text: "Isole Vergini Americane (+1)", value: "+1"},
          {index: 108, text: "Israele (+972)", value: "+972"},
          {index: 109, text: "Italia (+39)", value: "+39"},
          {index: 110, text: "Kazakistan (+7)", value: "+7"},
          {index: 111, text: "Kenya (+254)", value: "+254"},
          {index: 112, text: "Kirghizistan (+996)", value: "+996"},
          {index: 113, text: "Kiribati (+686)", value: "+686"},
          {index: 114, text: "Kosovo (+383)", value: "+383"},
          {index: 115, text: "Kuwait (+965)", value: "+965"},
          {index: 116, text: "Laos (+856)", value: "+856"},
          {index: 117, text: "Lesotho (+266)", value: "+266"},
          {index: 118, text: "Lettonia (+371)", value: "+371"},
          {index: 119, text: "Libano (+961)", value: "+961"},
          {index: 120, text: "Liberia (+231)", value: "+231"},
          {index: 121, text: "Libia (+218)", value: "+218"},
          {index: 122, text: "Liechtenstein (+423)", value: "+423"},
          {index: 123, text: "Lituania (+370)", value: "+370"},
          {index: 124, text: "Lussemburgo (+352)", value: "+352"},
          {index: 125, text: "Macao (+853)", value: "+853"},
          {index: 126, text: "Macedonia del Nord (+389)", value: "+389"},
          {index: 127, text: "Madagascar (+261)", value: "+261"},
          {index: 128, text: "Malawi (+265)", value: "+265"},
          {index: 129, text: "Maldive (+960)", value: "+960"},
          {index: 130, text: "Malesia (+60)", value: "+60"},
          {index: 131, text: "Mali (+223)", value: "+223"},
          {index: 132, text: "Malta (+356)", value: "+356"},
          {index: 133, text: "Marocco (+212)", value: "+212"},
          {index: 134, text: "Martinica (+596)", value: "+596"},
          {index: 135, text: "Mauritania (+222)", value: "+222"},
          {index: 136, text: "Mauritius (+230)", value: "+230"},
          {index: 137, text: "Messico (+52)", value: "+52"},
          {index: 138, text: "Micronesia (+691)", value: "+691"},
          {index: 139, text: "Moldavia (+373)", value: "+373"},
          {index: 140, text: "Mongolia (+976)", value: "+976"},
          {index: 141, text: "Montenegro (+382)", value: "+382"},
          {index: 142, text: "Montserrat (+1)", value: "+1"},
          {index: 143, text: "Mozambico (+258)", value: "+258"},
          {index: 144, text: "Myanmar (+95)", value: "+95"},
          {index: 145, text: "Namibia (+264)", value: "+264"},
          {index: 146, text: "Nauru (+674)", value: "+674"},
          {index: 147, text: "Nepal (+977)", value: "+977"},
          {index: 148, text: "Nicaragua (+505)", value: "+505"},
          {index: 149, text: "Niger (+227)", value: "+227"},
          {index: 150, text: "Nigeria (+234)", value: "+234"},
          {index: 151, text: "Niue (+683)", value: "+683"},
          {index: 152, text: "Norvegia (+47)", value: "+47"},
          {index: 153, text: "Nuova Caledonia (+687)", value: "+687"},
          {index: 154, text: "Nuova Zelanda (+64)", value: "+64"},
          {index: 155, text: "Oman (+968)", value: "+968"},
          {index: 156, text: "Paesi Bassi (+31)", value: "+31"},
          {index: 157, text: "Pakistan (+92)", value: "+92"},
          {index: 158, text: "Palau (+680)", value: "+680"},
          {index: 159, text: "Panama (+507)", value: "+507"},
          {index: 160, text: "Papua Nuova Guinea (+675)", value: "+675"},
          {index: 161, text: "Paraguay (+595)", value: "+595"},
          {index: 162, text: "Perù (+51)", value: "+51"},
          {index: 163, text: "Polinesia Francese (+689)", value: "+689"},
          {index: 164, text: "Polonia (+48)", value: "+48"},
          {index: 165, text: "Portogallo (+351)", value: "+351"},
          {index: 166, text: "Porto Rico (+1)", value: "+1"},
          {index: 167, text: "Principato di Monaco (+377)", value: "+377"},
          {index: 168, text: "Qatar (+974)", value: "+974"},
          {index: 169, text: "Regno Unito (+44)", value: "+44"},
          {index: 170, text: "Repubblica Ceca (+420)", value: "+420"},
          {index: 171, text: "Repubblica Centrafricana (+236)", value: "+236"},
          {index: 172, text: "Repubblica Democratica del Congo (+243)", value: "+243"},
          {index: 173, text: "Repubblica Dominicana (+1)", value: "+1"},
          {index: 174, text: "Reunion (+262)", value: "+262"},
          {index: 175, text: "Romania (+40)", value: "+40"},
          {index: 176, text: "Ruanda (+250)", value: "+250"},
          {index: 177, text: "Russia (+7)", value: "+7"},
          {index: 178, text: "Saint Barthélemy (+590)", value: "+590"},
          {index: 179, text: "Saint Elena (+290)", value: "+290"},
          {index: 180, text: "Saint Kitts e Nevis (+1)", value: "+1"},
          {index: 181, text: "Saint Martin (+590)", value: "+590"},
          {index: 182, text: "Saint-Pierre e Miquelon (+508)", value: "+508"},
          {index: 183, text: "Saint Vincent e Grenadine (+1)", value: "+1"},
          {index: 184, text: "Samoa (+685)", value: "+685"},
          {index: 185, text: "Samoa Americane (1)", value: "+1"},
          {index: 186, text: "San Marino (+378)", value: "+378"},
          {index: 187, text: "Santa Lucia (+1)", value: "+1"},
          {index: 188, text: "São Tomé e Príncipe (+239)", value: "+239"},
          {index: 189, text: "Senegal (+221)", value: "+221"},
          {index: 190, text: "Serbia (+381)", value: "+381"},
          {index: 191, text: "Seychelles (+248)", value: "+248"},
          {index: 192, text: "Sierra Leone (+232)", value: "+232"},
          {index: 193, text: "Singapore (+65)", value: "+65"},
          {index: 194, text: "Sint Maarten (+1)", value: "+1"},
          {index: 195, text: "Siria (+963)", value: "+963"},
          {index: 196, text: "Slovacchia (+421)", value: "+421"},
          {index: 197, text: "Slovenia (+386)", value: "+386"},
          {index: 198, text: "Somalia (+252)", value: "+252"},
          {index: 199, text: "Spagna (+34)", value: "+34"},
          {index: 200, text: "Sri Lanka (+94)", value: "+94"},
          {index: 201, text: "Sudafrica (+27)", value: "+27"},
          {index: 202, text: "Sudan (+249)", value: "+249"},
          {index: 203, text: "Sudan del Sud (+211)", value: "+211"},
          {index: 204, text: "Suriname (+597)", value: "+597"},
          {index: 205, text: "Svezia (+46)", value: "+46"},
          {index: 206, text: "Svizzera (+41)", value: "+41"},
          {index: 207, text: "Tagikistan (+992)", value: "+992"},
          {index: 208, text: "Taiwan (+886)", value: "+886"},
          {index: 209, text: "Tailandia (+66)", value: "+66"},
          {index: 210, text: "Tanzania (+255)", value: "+255"},
          {index: 211, text: "Timor Est (+670)", value: "+670"},
          {index: 212, text: "Togo (+228)", value: "+228"},
          {index: 213, text: "Tokelau (+690)", value: "+690"},
          {index: 214, text: "Tonga (+676)", value: "+676"},
          {index: 215, text: "Trinidad e Tobago (+1)", value: "+1"},
          {index: 216, text: "Tunisia (+216)", value: "+216"},
          {index: 217, text: "Turchia (+90)", value: "+90"},
          {index: 218, text: "Turkmenistan (+993)", value: "+993"},
          {index: 219, text: "Turks e Caicos (+1)", value: "+1"},
          {index: 220, text: "Tuvalu (+688)", value: "+688"},
          {index: 221, text: "Ucraina (+380)", value: "+380"},
          {index: 222, text: "Uganda (+256)", value: "+256"},
          {index: 223, text: "Ungheria (+36)", value: "+36"},
          {index: 224, text: "Uruguay (+598)", value: "+598"},
          {index: 225, text: "USA (+1)", value: "+1"},
          {index: 226, text: "Uzbekistan (+998)", value: "+998"},
          {index: 227, text: "Vanuatu (+678)", value: "+678"},
          {index: 228, text: "Venezuela (+58)", value: "+58"},
          {index: 229, text: "Vietnam (+84)", value: "+84"},
          {index: 230, text: "Wallis e Futuna (+681)", value: "+681"},
          {index: 231, text: "Yemen (+967)", value: "+967"},
          {index: 232, text: "Zambia (+260)", value: "+260"},
          {index: 233, text: "Zimbabwe (+263)", value: "+263"}
        ]
      }
    },
    computed: {
      messageClass() {
        if (!this.patientPhNo) {
          return {
            'md-invalid': this.patientPhNoIsEmpty
          }
        }
      }
    },
    mounted: function() {
      var self = this;
      var ua = window.navigator.userAgent;
      self.isIE = /MSIE|Trident/.test(ua);
      //console.log('inserisci il numero di telefono');
      var user = firebase.auth().currentUser;
      if (user){
        firebase
          .auth()
          .signOut();
      }
      var window_media = window.matchMedia("(max-width: 768px)");
      self.test_match_mview(window_media);
      window_media.addListener(self.test_match_mview);
      this.submitForm = $('.phone-form')
      this.setTrigger()
      
    },
    methods: {
      test_match_mview: function(window_media) {
        var self = this;
        //console.log("test_match_view");
        if (window_media.matches) {
          self.smallScreen = true;
          //console.log("small");
          //console.log(self.smallScreen);
        } else {
          self.smallScreen = false;
          //console.log("large");
          //console.log(self.smallScreen);
        }
      },
      informativa: function(event){
        this.privacy = !this.privacy;
        event.preventDefault();

        var self = this;
        var storage = firebase.storage();
        var pathReference = storage.ref('informativa/informativa.pdf');
        pathReference.getDownloadURL().then(function(url){
          window.open(
                  url,
                  "_blank",
                  "location=yes,height=570,width=520,scrollbars=yes,status=yes"
                );
        });

      },
      validatePhoneNumber: function(phoneNumber){
            var re = /^\+[0-9]*$/;
            return re.test(String(phoneNumber))
      },
      setTrigger () {
        var self = this
        //console.log('set trigger')
        self.submitForm.parsley().on('form:success', function () {
          //console.info('OK')
          self.submitRegistration()
        })
        self.submitForm.parsley().on('form:error', function () {
          console.error('Invalid Number')
          //TODO PUT MESSAGES
          // self.invalidEmail = true
          // $('#add-admin-email').blur()
          // self.addAdminValidationError()
        })
      },
      validateRegistration: function(event) {
        event.preventDefault()
        var self = this
        self.submitForm.parsley().validate()
      },
      getUserInfo: function(number) {
      var self = this;
      axios
        .post(
          "/getUserInfo",
          {
            userPhone: number
          },
          {
            headers: {
              //Authorization: 'Bearer ' + idToken
            }
          }
        )
        .then(function(data) {
          //console.log("SUCCESS");
          //console.log(data);
          if (data.data.data) {
            self.$store.commit("userFlux", self.$route.fullPath);
            self.$router.push({path: '/registration-upload'});
          } else {
            self.$notify({
              group: "foo",
              title: "Prego inserire un numero di telefono valido",
              text: "Il numero inserito non è tra quelli registrati",
              duration: 300
            });
          }
        })
        .catch(function(e) {
          //console.log("User Info retrieving failed because: ", e);
          //console.log("user not in db");
        });
      },
      submitRegistration: function() {
        var self = this
        var prefix = '+39'
        for (var i = 0; i < self.countries; i++) {
          var country = self.countries[i]
          if (country.index == self.patientPhPrefix) {
            prefix = country.value
            break
          }
        }
        var number = prefix + self.patientPhNo
           if (!self.validatePhoneNumber(number)) {
            self.$notify({
              group: 'foo',
              title: 'Prego inserire un numero di telefono valido',
              text: 'Il formato inserito non è valido',
              duration: 300,
            });
          }else {
            self.$store.commit('userPhone', number);
            self.getUserInfo(number);

          }

      },
    }
  }
</script>

<style scoped>
  /* "scoped" attribute limit the CSS to this component only */
  .logo_navbar {
    text-align: center;
    height: 40px;
    padding: 3px;
  }

  .privacy-card {
    text-align: left;
    padding-bottom: 0;
  }
  .button-card {
    padding-top:0;
  }

  .md-card-actions .md-button:last-child {
    margin-right: 9px;
    margin-bottom: 9px;
  }
  .submit-button {
  }

  .md-card {
    width: 60%;
    margin: 4px;
    display: inline-block;
    vertical-align: center;
  }

  @media only screen and (max-width: 600px) {
    .md-card {
      width: 80%;
    }
  }

  .logo {
    margin-top: 60px;
    width: 10%;
    height: 10%;
  }

  .title-style {
    color: #027953;
    font-size: 20px;
  }

  .text-style {
    color: #027953;
    font-size: 15px;
    text-align: center;
    padding-top: 1%;
  }



  .logo_navbar {
    text-align: center;
    height: 40px;
    padding: 3px;
  }





  .logout {
    margin-top: 40px;
  }

  .home-button {
    width: 487px;
  }



  .nav-style {
    height: 50px;
  }

  .second-navbar {
    background-color: #027953;
    font-size: 26px;
    font-weight: bold;
    color: #FFFFFF;
    padding: 1.3%
  }


  .text-card {
    text-align: right;
    color: grey;
  }


  .first-nav {
    background-color:  #FFFFFF !important;
  }



  .simple-text {
    color: black;
    font-size: 17px;
  }

  .button-text {

    padding-top:6%;
    padding-left: 1%;
    float:right;
  }

</style>



// WEBPACK FOOTER //
// src/components/InsertPhone.vue